import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.css';
import { removeUserSession } from '../utils/comman/Common';


export const baseURL = process.env.REACT_APP_BASE_URL;
let headers = {};

const axiosinstances = () => {
  const token = sessionStorage.getItem('token')
  // const navigate = useNavigate();
  if(token){
   headers.Authorization = `Bearer ${token}`
}
  const axiosInstance = axios.create({
    baseURL: baseURL,
  timeout: 50000,
  headers: {'X-Custom-Header': 'foobar', ...headers},
});
// client.interceptors.response.use(undefined, err => {})
axiosInstance.interceptors.response.use(response => {
  return response;
}, error => {
 if (error.response.status === 401) {
  removeUserSession();
  alert("Your session has expired, plz login again");
  window.location.reload();
 }
 return error;
});

  return [axiosInstance];
};

export default axiosinstances;




